import { render, staticRenderFns } from "./AmountSel.vue?vue&type=template&id=200365d1&scoped=true"
import script from "./AmountSel.vue?vue&type=script&lang=js"
export * from "./AmountSel.vue?vue&type=script&lang=js"
import style0 from "./AmountSel.vue?vue&type=style&index=0&id=200365d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200365d1",
  null
  
)

export default component.exports